import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Form as FinalForm } from 'react-final-form';

import type { IFormDeps, IForm } from './models';
import { FormWrapperAdapter } from './components/form-wrapper-adapter/mobile';

export const SmeFormMobile = createWidget<IFormDeps, IForm>({ FinalForm })(FormWrapperAdapter);
